(function () {
    "use strict";

    angular
        .module("legitimation.config", [])

        .constant("temlateUrls", {
            login: "/privat/handys-tablets-tarife/legitimation-login.html",
            upload: "/privat/handys-tablets-tarife/legitimation-upload.html",
        })

        .value("config", GLOBALURLS);
})();
